module.exports = __webpack_public_path__ + "img/07.044f57ac.jpg";